import { Badge } from '@janeapp/burrito-design-system';
import { OpeningBadgeStatus } from '~/utilities';

interface OpeningBadgeProps {
  badgeStatus?: OpeningBadgeStatus;
  className?: string;
}

export const OpeningBadge = ({
  badgeStatus,
  className = '',
}: OpeningBadgeProps) => {
  if (!badgeStatus) {
    return null;
  }

  return (
    <Badge data-testid="opening-badge" tone="brand" className={className}>
      {badgeStatus}
    </Badge>
  );
};
